import React from "react";
import { Box, Typography } from "@mui/material";
//import LiabilityStyles from "../Property/PropertyStyles";
import RiskAndCoverageStyle from "../RiskAndCoverage/RiskAndCoverageStyles"
export const renderField = (label: string, value: any, t: Function) => {
  return (
    <Box sx={RiskAndCoverageStyle.liabilityLabelValueContainer}>
      <Typography sx={RiskAndCoverageStyle.claimsCardItemHeading}>
        {value || "-"}
      </Typography>
      <Typography sx={RiskAndCoverageStyle.claimsCartItemContent}>
        {t(label)}
      </Typography>
    </Box>
  );
};

export const getRiskSpecificFields = (policyRisk: any, lobCode: string, t: Function) => {
  if (lobCode !== "FO") {
    const fields = [
      { label: "Risk Type", value: policyRisk.riskType },
      { label: "Business Category", value: policyRisk.businessCategory },
      { label: "Class", value: policyRisk.businessClass },
      { label: "Interest Type", value: policyRisk.interestType },
      { label: "Roof Type", value: policyRisk.roofType },
      { label: "No. of Stories", value: policyRisk.numberOfStories },
      { label: "Construction Type", value: policyRisk.constructionType },
      { label: "Occupancy Type", value: policyRisk.occupancyType },
      { label: "Inspected On", value: policyRisk.inspectionDt },
      { label: "Territory", value: policyRisk.territoryCd },
      { label: "Burglar Alarm", value: policyRisk.burglarAlarm },
      { label: "Certificate", value: policyRisk.certificate },
      { label: "ExpirationDate", value: policyRisk.expirationDt },
      { label: "Extent", value: policyRisk.extent },
      { label: "Grade", value: policyRisk.grade },
      {
        label: "Installed/Serviced By",
        value: policyRisk.installedOrServicedby,
      },
      { label: "Fire Protection", value: policyRisk.fireProtection },
      { label: "Fire Alarm", value: policyRisk.fireAlarm },
      { label: "Manufacturer", value: policyRisk.manufacturer },
      { label: "Sprinkler System", value: policyRisk.sprinklerSystem },
    ];

    return (
      <>{fields.map((field) => renderField(field.label, field.value, t))}</>
    );
  }

  const riskType = policyRisk?.riskType;

  const fieldMappings: Record<
    string,
    Array<{ label: string; value: string }>
  > = {
    "Additional Dwelling": [
      { label: "Risk Sub Type", value: policyRisk?.riskSubType },
      { label: "Policy Form", value: policyRisk?.policyForm },
      { label: "Construction Type", value: policyRisk?.constructionType },
      { label: "Square Footage", value: policyRisk?.squareFootage },
      { label: "Roof Year", value: policyRisk?.roofYear },
      { label: "Heat Type", value: policyRisk?.heatType },
      { label: "Purchase Price", value: policyRisk?.purchasePrice },
      { label: "Year Built", value: policyRisk?.yearBuilt },
      { label: "Dwelling Type", value: policyRisk?.dwellingType },
      { label: "Electrical Amperage", value: policyRisk?.electricalAmperage },
      { label: "Year Heat Updated", value: policyRisk?.yearHeatUpdated },
      { label: "Market Value", value: policyRisk?.marketValue },
      { label: "Roof Type", value: policyRisk?.roofType },
      { label: "Year Wiring Updated", value: policyRisk?.yearWiringUpdated },
      { label: "Year Purchased", value: policyRisk?.yearPurchased },
      {
        label: "Families Living in Dwelling?",
        value: policyRisk?.familiesLivingInDwelling,
      },
      {
        label: "Home Protection Device",
        value: policyRisk?.homeProtectionDevice,
      },
      { label: "Deductible", value: policyRisk?.deductible },
      { label: "All Other Peril", value: policyRisk?.allOtherPeril },
      { label: "Wind/Hail", value: policyRisk?.windOrHail },
    ],
    "Owner Occupied Dwelling": [
      { label: "Policy Form", value: policyRisk?.policyForm },
      { label: "Construction Type", value: policyRisk?.constructionType },
      { label: "Square Footage", value: policyRisk?.squareFootage },
      { label: "Roof Year", value: policyRisk?.roofYear },
      { label: "Heat Type", value: policyRisk?.heatType },
      { label: "Purchase Price", value: policyRisk?.purchasePrice },
      { label: "Year Built", value: policyRisk?.yearBuilt },
      { label: "Dwelling Type", value: policyRisk?.dwellingType },
      { label: "Electrical Amperage", value: policyRisk?.electricalAmperage },
      { label: "Year Heat Updated", value: policyRisk?.yearHeatUpdated },
      { label: "Market Value", value: policyRisk?.marketValue },
      { label: "Roof Type", value: policyRisk?.roofType },
      { label: "Year Wiring Updated", value: policyRisk?.yearWiringUpdated },
      { label: "Year Purchased", value: policyRisk?.yearPurchased },
      {
        label: "Families Living in Dwelling?",
        value: policyRisk?.familiesLivingInDwelling,
      },
      {
        label: "Home Protection Device",
        value: policyRisk?.homeProtectionDevice,
      },
      { label: "Deductible", value: policyRisk?.deductible },
      { label: "All Other Peril", value: policyRisk?.allOtherPeril },
      { label: "Wind/Hail", value: policyRisk?.windOrHail },
    ],
    "Contents Only": [
      { label: "Policy Form", value: policyRisk?.policyForm },
      { label: "Construction Type", value: policyRisk?.constructionType },
      { label: "Occupied By", value: policyRisk?.occupiedBy },
      {
        label: "Home Protection Device",
        value: policyRisk?.homeProtectionDevice,
      },
      { label: "Deductible", value: policyRisk?.deductible },
      { label: "All Other Peril", value: policyRisk?.allOtherPeril },
      { label: "Wind/Hail", value: policyRisk?.windOrHail },
    ],
    "Barn, Building or Structure": [
      { label: "Risk Sub Type", value: policyRisk?.riskSubType },
      { label: "Description", value: policyRisk?.description },
      { label: "Policy Form", value: policyRisk?.policyForm },
      { label: "Blanket/Scheduled", value: policyRisk?.blanketOrScheduled },
      { label: "Length", value: policyRisk?.length },
      { label: "Width", value: policyRisk?.width },
      { label: "Height", value: policyRisk?.height },
      { label: "Construction Type", value: policyRisk?.constructionType },
      { label: "Year Built", value: policyRisk?.yearBuilt },
      {
        label: "Structure has a roof?",
        value: policyRisk?.structureHasARoof,
      },
      { label: "Deductible", value: policyRisk?.deductible },
      { label: "All Other Peril", value: policyRisk?.allOtherPeril },
      { label: "Wind/Hail", value: policyRisk?.windOrHail },
    ],
    "Unit Owners": [
      { label: "Risk Sub Type", value: policyRisk?.riskSubType },
      { label: "Policy Form", value: policyRisk?.policyForm },
      { label: "Describe Home", value: policyRisk?.describeHome },
      { label: "Roof Year", value: policyRisk?.roofYear },
      { label: "Year Built", value: policyRisk?.yearBuilt },
      { label: "Roof Type", value: policyRisk?.roofType },
      { label: "Number of Units", value: policyRisk?.numberOfUnits },
      { label: "Construction Type", value: policyRisk?.constructionType },
      {
        label: "Home Protection Device",
        value: policyRisk?.homeProtectionDevice,
      },
      { label: "Deductible", value: policyRisk?.deductible },
      { label: "All Other Peril", value: policyRisk?.allOtherPeril },
      { label: "Wind/Hail", value: policyRisk?.windOrHail },
    ],
  };

  if (riskType === "Farm Personal Property") {
    const fields = [
      { label: "Risk Type", value: policyRisk?.riskType },
      { label: "Blanket/Scheduled", value: policyRisk?.blanketOrScheduled },
      { label: "Risk Sub Type", value: policyRisk?.riskSubType },
    ];

    if (
      policyRisk?.blanketOrScheduled === "Blanket" &&
      [
        "Farm Machinery",
        "Farm Supplies",
        "Grain/Farm Product",
        "Hay/Sileage",
        "Livestock",
        "Misc. Tools and Equipment",
      ].includes(policyRisk?.riskSubType)
    ) {
      fields.push(
        { label: "Item Value", value: policyRisk?.itemValue },
        { label: "Deductible", value: policyRisk?.deductible },
        { label: "All Other Peril", value: policyRisk?.allOtherPeril },
        { label: "Wind/Hail", value: policyRisk?.windOrHail }
      );
    }

    if (policyRisk?.blanketOrScheduled === "Scheduled") {
      fields.push(
        { label: "Policy Form", value: policyRisk?.policyForm },
        { label: "Deductible", value: policyRisk?.deductible },
        { label: "All Other Peril", value: policyRisk?.allOtherPeril },
        { label: "Wind/Hail", value: policyRisk?.windOrHail }
      );

      if (
        ["Farm Machinery", "Irrigation Equipment"].includes(
          policyRisk?.riskSubType
        )
      ) {
        fields.push(
          { label: "Item Type", value: policyRisk?.itemType },
          { label: "Item Value", value: policyRisk?.itemValue },
          { label: "Year", value: policyRisk?.year },
          { label: "Make", value: policyRisk?.make },
          { label: "Model", value: policyRisk?.model },
          { label: "Serial Number", value: policyRisk?.serialNumber }
        );
      } else if (policyRisk?.riskSubType === "Farm Supplies") {
        fields.push(
          { label: "Item Type", value: policyRisk?.itemType },
          { label: "Number of Units", value: policyRisk?.numberOfUnits },
          { label: "Unit Value", value: policyRisk?.unitValue },
          { label: "Item Value", value: policyRisk?.itemValue }
        );

        if (policyRisk?.itemType === "Other") {
          fields.push({
            label: "Other Description",
            value: policyRisk?.otherDescription,
          });
        }
      } else if (
        [
          "Grain/Farm Product",
          "Hay in the Building",
          "Hay in the Open",
        ].includes(policyRisk?.riskSubType)
      ) {
        fields.push(
          { label: "Item Type", value: policyRisk?.itemType },
          { label: "Unit Description", value: policyRisk?.unitDescription },
          { label: "Number of Units", value: policyRisk?.numberOfUnits },
          { label: "Unit Value", value: policyRisk?.unitValue },
          { label: "Item Value", value: policyRisk?.itemValue }
        );
      } else if (["Livestock", "Poultry"].includes(policyRisk?.riskSubType)) {
        fields.push(
          { label: "Item Type", value: policyRisk?.itemType },
          {
            label: "Is this a Show animal?",
            value: policyRisk?.isThisAShowAnimal,
          },
          { label: "Number of Units", value: policyRisk?.numberOfUnits },
          { label: "Unit Value", value: policyRisk?.unitValue },
          { label: "Item Value", value: policyRisk?.itemValue }
        );

        if (policyRisk?.itemType === "Other") {
          fields.push({
            label: "Other Description",
            value: policyRisk?.otherDescription,
          });
        }
      } else if (policyRisk?.riskSubType === "Portable Buildings") {
        fields.push(
          { label: "Item Type", value: policyRisk?.itemType },
          { label: "Item Value", value: policyRisk?.itemValue },
          { label: "Length", value: policyRisk?.length },
          { label: "Width", value: policyRisk?.width },
          { label: "Height", value: policyRisk?.height },
          { label: "Year Building", value: policyRisk?.yearBuilding },
          { label: "Roof Type", value: policyRisk?.roofType },
          { label: "Construction Type", value: policyRisk?.constructionType },
          {
            label: "How is the building secured?",
            value: policyRisk?.howIsTheBuildingSecured,
          }
        );
      } else if (policyRisk?.riskSubType === "All Other Farm Property") {
        fields.push(
          { label: "Item Type", value: policyRisk?.itemType },
          { label: "Number of Units", value: policyRisk?.numberOfUnits },
          { label: "Unit Value", value: policyRisk?.unitValue },
          { label: "Item Value", value: policyRisk?.itemValue }
        );
      }
    }

    return (
      <>{fields.map((field) => renderField(field.label, field.value, t))}</>
    );
  }

  if (
    riskType === "Barn, Building or Structure" &&
    policyRisk?.structureHasARoof === "Yes"
  ) {
    return (
      <>
        {(fieldMappings[riskType] || []).map((field) =>
          renderField(field.label, field.value, t)
        )}
        {renderField("Roof Type", policyRisk?.roofType, t)}
      </>
    );
  }

  const fields = fieldMappings[riskType] || [];

  return <>{fields.map((field) => renderField(field.label, field.value, t))}</>;
};
